import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

// Shown when the ticket could not be opened - stays open until the customer acknowledges it
const TicketNotCreatedDialog = ({ open, onClose }) => {
  return (
    <Dialog open={open} dir="rtl" disableEscapeKeyDown>
      <DialogTitle sx={{ color: "error.main" }}>הקריאה לא נפתחה</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ color: "text.primary" }}>
          בעקבות תקלה לא נפתחה קריאה, עליך לפנות למחלקת השירות טלפונית.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" autoFocus>
          הבנתי
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TicketNotCreatedDialog;
